import React, { Component } from 'react';
import SideNav from '../layouts/SideNav';
import TopNav from '../layouts/TopNav';
import PageTitle  from '../layouts/PageTitle';
import PrevIcon from '../layouts/PrevIcon';
import NextIcon from '../layouts/NextIcon';

import { ajaxCall, closeAlert, confirmPrompt, errorAction, Preloader, tinyAlert } from '../helpers/Helpers'


class FIDepartment extends Component {
  componentDidMount() {
    this.GetFIDepartment();
  }

  state = {
    allFIDept:[],
    filteredFIDept:[],
    currentPageFIDept:[],

    numRecordsPerPage: 25,
    currentPage: 1,
    numOfPages: 1,
    form: {
      dept:'',
      fiReviewersList:''
    },
  }

  handleFormInputsChange = (e) => { this.setState(prevState => ({ form: { ...prevState.form, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value } })) }

  GetFIDepartment = () => {
    Preloader();
    
    ajaxCall('FIDept').then(res => {
      closeAlert();
      this.setState({ allFIDept: res.data.data }, this.filteredFITable);
    })
    .catch(error => {
      errorAction(error);
    })
  }
  
  filteredFITable = (e) => {
    let result
    if (e != null) {
      let search = e.target.value.toLowerCase();
      result = this.state.allFIDept.filter((x) => x.dept.toLowerCase().includes(search) || x.fiReviewersList.join(',').toLowerCase().includes(search));
    }
    else
      result = this.state.allFIDept;

    this.setState({ filteredFIDept: result.map((r, i) => ({ ...r, index: i + 1 })) }, this.updateTablePagination);
  }

  updateTablePagination = () => {
    let recordCount = this.state.filteredFIDept.length
    let numOfPages = Math.ceil(recordCount / this.state.numRecordsPerPage)
    let currentPage = this.state.currentPage
    if (currentPage < 1) currentPage = 1;
    if (currentPage > numOfPages) currentPage = numOfPages;
    this.setState({ currentPage: currentPage, numOfPages: numOfPages }, this.setRecordsForCurrentPage)
  }

  setRecordsForCurrentPage = () => {
    const offset = (this.state.currentPage - 1) * this.state.numRecordsPerPage;
    this.setState({ currentPageFIDept: this.state.filteredFIDept.slice(offset, offset + this.state.numRecordsPerPage) });
  }

  setNumRecordsPerPage = (e) => {
    this.setState({ numRecordsPerPage: Number(e.target.value) }, this.updateTablePagination);
  }

  nextPage = (e) => {
    this.setState({ currentPage: Number(this.state.currentPage) + 1 }, this.setRecordsForCurrentPage);
  }

  previousPage = (e) => {
    this.setState({ currentPage: Number(this.state.currentPage) - 1 }, this.setRecordsForCurrentPage);
  }

  editRecord = (id, status) => {
    return this.state.allFIDept.map(item => {
        var temp = Object.assign({}, item);
        if (temp.id === id) {
            temp.active = status;
        }
        return temp;
    });
  }

  EnableFIDept = (id) => {
    Preloader();
    
    ajaxCall("FIDept/EnableFIDept/"+id, 'json', 'patch').then(res => {
      tinyAlert('success',res.data.message); closeAlert();      
           
      let record = this.editRecord(id, true);
      this.setState({ allFIDept: record }, this.filteredFITable);
    })
    .catch(error => {
      errorAction(error);
    })
  }

  DisableFIDept= (id) => {
    Preloader();

    ajaxCall("FIDept/DisableFIDept/"+id, 'json', 'patch').then(res => {
      tinyAlert('success',res.data.message); closeAlert();      
           
      let record = this.editRecord(id, false);
      this.setState({ allFIDept: record }, this.filteredFITable);
    })
    .catch(error => {
      errorAction(error);
    })
  }

  UpdateFIDept = (data) => {
    Preloader();
    let form = {};    
    form.dept = data.dept;
    form.fiReviewersList = data.fiReviewersList;

    ajaxCall("FIDept/"+data.id, 'json', 'put', form).then(res => {
      tinyAlert('success','FI department updated successfully.'); closeAlert()
    })
    .catch(error => {
      errorAction(error);
    })
  }
  
  AddFIDept = () => {
    Preloader();
    let form = {};
    form.dept = this.state.form.dept;
    form.fiReviewersList = this.state.form.fiReviewersList.split(',');
    
    ajaxCall('FIDept', 'json', 'post', form).then(res => {
      tinyAlert('success','FI department created successfully.');  closeAlert();

      let data = res.data.data;
      let records = this.state.allFIDept;
      records.push(data);
      
      this.setState({ allFIDept: records }, this.filteredFITable);
      this.setState({ form: { dept:'', fiReviewersList:''} })
    })
    .catch(error => {
      errorAction(error);
    })
  }

  handleChangeInfo = (e, x) => {
    this.setState({
      allFIDept: this.state.allFIDept.map(g => g.id === x.id ? { ...g, [e.target.name] : e.target.name !== 'fiReviewersList' ? e.target.value: e.target.value.replaceAll(' ','').split(',') } : g),
      filteredFIDept: this.state.filteredFIDept.map(g =>  g.id === x.id ? { ...g, [e.target.name] : e.target.name !== 'fiReviewersList' ? e.target.value:  e.target.value.replaceAll(' ','').split(',')} : g),
      currentPageFIDept: this.state.currentPageFIDept.map(g =>  g.id === x.id ? { ...g, [e.target.name] : e.target.name !== 'fiReviewersList' ? e.target.value:  e.target.value.replaceAll(' ','').split(',')} : g)
    }, this.filteredFITable)
  }


  render() {
    return (
      
      <div className='mainApp'>
      <div className='container-fluid'>
        <div className='row'>
          <SideNav />
          
          <div className='main-content-wrap'>
            <TopNav />
            <PageTitle pagedata={{page:'Non-Po Departments',breadcrumb:'Non-Po Departments'}}/>

            <div className='container mt-1 mb-5'>
              <div className='row'>

                <div className='col-12 px-4'>
                  <div className='mt-4 mb-4'>
                    <div className='mb-3 mt-1' style={{position:'relative'}}>
                      <input type="text" className="form-control input-font bold" placeholder='Search...' onInput={this.filteredFITable}/>
                      <i className='fa fa-search' style={{position:'absolute', right:'20px', top:'12px', color:'#939597'}}></i>
                    </div>

                    <div className='table-responsive'>
                      <table className="table font-12 table-striped table-hover mb-1 table-bordered">
                        <thead className='text-white'>
                          <tr>
                            <th style={{width:'20px'}} className='text-center'>SN</th>
                            <th style={{width:'200px'}}>Name</th>
                            <th>Reviewer's Email Addresses</th>
                            <th style={{width:'60px'}}>Active</th>
                            <th style={{width:'50px'}}></th>
                            <th style={{width:'50px'}}></th>
                          </tr>
                        </thead>
                        <tbody className='font-12'>
                          {
                            this.state.currentPageFIDept.map(object => {
                              return (
                              <tr key={object.index}>
                                <td className='text-center'>{object.index}</td>
                                <td>                              
                                  <input type="text" name='dept' value={object.dept} onChange={(e) => this.handleChangeInfo(e,object)} className="form-control input-font p-1" />
                                </td>
                                <td>
                                  <input type="text" name='fiReviewersList' value={object.fiReviewersList.join(',')} onChange={(e) => this.handleChangeInfo(e,object)} className="form-control input-font p-1" />
                                </td>

                                <td className='text-center'>{object.active ? 'Yes' : 'No'}</td>
                                
                                <td><button className={object.active ? 'btn-danger btn btn-sm bold border-radius-sm' : 'btn-success btn btn-sm bold border-radius-sm'}   onClick={() => confirmPrompt(`Do you want to ${object.active ? "Disable" : "Enable"} department?`).then( (r) => r.isConfirmed ? object.active ? this.DisableFIDept(object.id) : this.EnableFIDept(object.id) : false)} >{object.active ? 'Disable' : 'Enable'}</button></td>

                                <td><button className='btn btn-sm btn-info bold border-radius-sm checkBtn' onClick={() => confirmPrompt(`Do you want to update department?`).then( (r) => r.isConfirmed ? this.UpdateFIDept(object) : false)}>Update</button></td>                                   
                              </tr>
                              )
                            })
                          } 

                          <tr>
                            <td className='text-center'></td>
                            <td>                                        
                              <input type="text" placeholder='Department' name='dept' value={this.state.form.dept} onChange={this.handleFormInputsChange} className="form-control input-font p-1" />
                            </td>
                            <td>
                              <input type="text" placeholder='Email separated by comma' name='fiReviewersList' value={this.state.form.fiReviewersList} onChange={this.handleFormInputsChange} className="form-control input-font p-1" />
                            </td>
                            <td><button className='btn btn-sm btn-success bold border-radius-sm form-control' onClick={() => this.AddFIDept()}>Create</button></td>
                          
                            <td> </td>
                            <td> </td>
                            
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    { this.state.allFIDept.length === 0 ? <p className='font-12 text-center p-3'>Ops! No record available...</p>: '' }

                    <div className="row mb-2 mt-2">
                      <div className='col-8'></div>
                      <div className='col-1 text-end'>
                        <label className='font-12'>Per Page:</label>
                      </div>
                      <div className='col-1'>
                        <select className='font-12 form-select border-radius-sm' value={this.state.numRecordsPerPage} onChange={this.setNumRecordsPerPage}>
                          <option value='3'>3</option>
                          <option value='5'>5</option>
                          <option value='10'>10</option>
                          <option value='25'>25</option>
                          <option value='100'>100</option>
                          <option value='250'>250</option>
                        </select>
                      </div>
                      <div className='col-1 p-0'>
                        <button className='btn bg-light font-12 border-radius-sm' disabled={this.state.currentPage === 1} onClick={this.previousPage}><PrevIcon /> Prev</button>
                      </div>
                      <div className='col-1 p-0'>
                        <button className='btn bg-light font-12 border-radius-sm' disabled={this.state.currentPage === this.state.numOfPages} onClick={this.nextPage}>Next <NextIcon /></button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default FIDepartment;